// @ts-nocheck
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import * as Types from "../../__generated__/schema.graphql.types";

const defaultOptions = {} as const;
export type PayrollCompanyComponentUrlQueryVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
  componentType: Types.CheckCompanyComponent;
}>;

export type PayrollCompanyComponentUrlQuery = {
  __typename?: "query_root";
  payroll?: {
    __typename?: "PayrollType";
    company?: {
      __typename?: "CompanyType";
      id: string;
      componentUrl?: string | null;
    } | null;
  } | null;
};

export type PayrollOnboardQueryVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
  userMedspaId: Types.Scalars["bigint"]["input"];
}>;

export type PayrollOnboardQuery = {
  __typename?: "query_root";
  payroll?: {
    __typename?: "PayrollType";
    company?: {
      __typename?: "CompanyType";
      workerCount?: number | null;
      bankAccountStatus?: Types.BankAccountStatus | null;
      latestFeinVerificationStatus?: Types.FeinVerificationStatus | null;
      isBusinessDetailsCompleted: boolean;
      isPayHistoryCompleted: boolean;
      isFirstPayroll?: boolean | null;
      filingAuthorizationBlockingCount?: number | null;
      filingAuthorizationNeedsAttentionCount?: number | null;
      teamSetupEmployeesBlockingCount?: number | null;
      teamSetupContractorsBlockingCount?: number | null;
      teamSetupEmployeesNeedsAttentionCount?: number | null;
      teamSetupContractorsNeedsAttentionCount?: number | null;
      teamSetupCurrentUser?: boolean | null;
      companyDefinedEmployeeSetupBlockingCount?: number | null;
      companyDefinedEmployeeSetupNeedsAttentionCount?: number | null;
      companyDefinedEmployeeSetupCurrentUser?: boolean | null;
      taxSetupBlockingCount?: number | null;
      taxSetupNeedsAttentionCount?: number | null;
      taxSetupJurisdictionsMissingTaxId?: Array<string | null> | null;
      businessType?: string | null;
      industryType?: string | null;
      legalName?: string | null;
      phone?: string | null;
      email?: string | null;
      address?: string | null;
      implementationStatus: Types.PayrollCompanyImplementationStatusChoices;
      isReadyForImplementation?: boolean | null;
      onboardStatus?: Types.OnboardStatus | null;
      isRegistered?: boolean | null;
      isInNonMsoState?: boolean | null;
      documentRequests?: Array<{
        __typename?: "RequirementType";
        id?: number | null;
        title?: string | null;
        status?: Types.RequirementStatus | null;
        errors?: Array<string | null> | null;
      } | null> | null;
      fundingFailures?: Array<{
        __typename?: "RequirementType";
        id?: number | null;
        title?: string | null;
        status?: Types.RequirementStatus | null;
        errors?: Array<string | null> | null;
      } | null> | null;
    } | null;
  } | null;
  userMedspaByPk?: {
    __typename?: "userMedspa";
    user: { __typename?: "user"; fullName?: string | null };
    payrollSignatory?: {
      __typename?: "PayrollSignatory";
      title: string;
    } | null;
  } | null;
};

export type PayrollPayScheduleQueryVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type PayrollPayScheduleQuery = {
  __typename?: "query_root";
  payroll?: {
    __typename?: "PayrollType";
    company?: {
      __typename?: "CompanyType";
      paySchedule?: {
        __typename?: "PayScheduleType";
        id: string;
        payFrequency: Types.PayrollPaySchedulePayFrequencyChoices;
        nextPayoutDate?: string | null;
      } | null;
    } | null;
  } | null;
};

export type PayrollViewInfoQueryVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
  skipFundingFailures?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type PayrollViewInfoQuery = {
  __typename?: "query_root";
  payroll?: {
    __typename?: "PayrollType";
    isCurrentUserRegisteredEmployee?: boolean | null;
    isCurrentUserRegisteredContractor?: boolean | null;
    isCurrentUserOnboarded?: boolean | null;
    company?: {
      __typename?: "CompanyType";
      fundingFailures?: Array<{
        __typename?: "RequirementType";
        id?: number | null;
        title?: string | null;
        status?: Types.RequirementStatus | null;
        errors?: Array<string | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type RunPayrollReadyQueryVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type RunPayrollReadyQuery = {
  __typename?: "query_root";
  payroll?: {
    __typename?: "PayrollType";
    company?: {
      __typename?: "CompanyType";
      runPayrollReady?: boolean | null;
      onboardStatus?: Types.OnboardStatus | null;
      implementationStatus: Types.PayrollCompanyImplementationStatusChoices;
    } | null;
  } | null;
};

export type PayrollPreliminaryInfoQueryVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type PayrollPreliminaryInfoQuery = {
  __typename?: "query_root";
  payroll?: {
    __typename?: "PayrollType";
    isCurrentUserRegisteredInCheck?: boolean | null;
    isCompanyRegisteredInCheck?: boolean | null;
  } | null;
};

export type WorkerOnboardUrlQueryVariables = Types.Exact<{
  userMedspaId: Types.Scalars["ID"]["input"];
}>;

export type WorkerOnboardUrlQuery = {
  __typename?: "query_root";
  payroll?: {
    __typename?: "PayrollType";
    employeeOrContractorOnboardingUrl?: string | null;
  } | null;
};

export type PayrollEmployeeDataQueryVariables = Types.Exact<{
  medspaId: Types.Scalars["bigint"]["input"];
}>;

export type PayrollEmployeeDataQuery = {
  __typename?: "query_root";
  medspaByPk?: {
    __typename?: "medspa";
    id: string;
    payrollCompany?: {
      __typename?: "PayrollCompany";
      isFirstPayroll?: boolean | null;
    } | null;
  } | null;
  userMedspa: Array<{
    __typename?: "userMedspa";
    id: string;
    userMedspaRole?: { __typename?: "Role"; id: string; name: string } | null;
    user: {
      __typename?: "user";
      id: string;
      firstName: string;
      lastName: string;
      fullName?: string | null;
    };
    payrollContractor?: {
      __typename?: "PayrollContractor";
      id: string;
      startDate?: string | null;
      onboardStatus: string;
      terminationDate?: string | null;
      onboardBlockingTypeSubmitted: boolean;
      onboardBlockingEinSubmitted: boolean;
      onboardBlockingAddressSubmitted: boolean;
      onboardNeedsAttentionSsnSubmitted: boolean;
      onboardNeedsAttentionSsnValidated: boolean;
      onboardNeedsAttentionPaymentMethodPreferenceSet: boolean;
      onboardNeedsAttentionBankAccountExists: boolean;
      onboardNeedsAttentionBankAccountVerified: boolean;
    } | null;
    payrollEmployee?: {
      __typename?: "PayrollEmployee";
      id: string;
      employmentDate?: string | null;
      onboardStatus: string;
      terminationDate?: string | null;
      onboardBlockingPrimaryWorkplaceSet: boolean;
      onboardBlockingStartDate: boolean;
      onboardBlockingDob: boolean;
      onboardBlockingResidence: boolean;
      onboardNeedsAttentionSsnSubmitted: boolean;
      onboardNeedsAttentionSsnValidated: boolean;
      onboardNeedsAttentionPaymentMethodPreferenceSet: boolean;
      onboardNeedsAttentionBankAccountExists: boolean;
      onboardNeedsAttentionBankAccountVerified: boolean;
      onboardWithholdings: Array<{
        __typename?: "PayrollEmployeeOnboardWithholding";
        id: string;
        name: string;
        status: string;
      }>;
      onboardCompanyDefinedAttributes: Array<{
        __typename?: "PayrollEmployeeOnboardCompanyDefinedAttribute";
        id: string;
        name: string;
        status: string;
      }>;
    } | null;
  }>;
};

export type MarkBusinessDetailsCompletedMutationVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type MarkBusinessDetailsCompletedMutation = {
  __typename?: "mutation_root";
  payroll?: {
    __typename?: "PayrollMutations";
    markBusinessDetailsCompleted?: {
      __typename?: "MarkBusinessDetailsCompleted";
      ok: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type MarkPayHistoryCompletedMutationVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type MarkPayHistoryCompletedMutation = {
  __typename?: "mutation_root";
  payroll?: {
    __typename?: "PayrollMutations";
    markPayHistoryCompleted?: {
      __typename?: "MarkPayHistoryCompleted";
      ok: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type SendOnboardRemindersToWorkersMutationVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type SendOnboardRemindersToWorkersMutation = {
  __typename?: "mutation_root";
  payroll?: {
    __typename?: "PayrollMutations";
    sendOnboardRemindersToWorkers?: {
      __typename?: "SendOnboardRemindersToWorkers";
      ok: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type StartImplementationMutationVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type StartImplementationMutation = {
  __typename?: "mutation_root";
  payroll?: {
    __typename?: "PayrollMutations";
    startImplementation?: {
      __typename?: "StartImplementation";
      ok: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type CreateOrUpdateSignatoryMutationVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
  title: Types.Scalars["String"]["input"];
}>;

export type CreateOrUpdateSignatoryMutation = {
  __typename?: "mutation_root";
  payroll?: {
    __typename?: "PayrollMutations";
    createOrUpdateSignatory?: {
      __typename?: "CreateOrUpdateSignatory";
      ok: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export const PayrollCompanyComponentUrlDocument = gql`
  query PayrollCompanyComponentUrl(
    $medspaId: String!
    $componentType: CheckCompanyComponent!
  ) {
    payroll {
      company(medspaId: $medspaId) {
        id
        componentUrl(componentType: $componentType)
      }
    }
  }
`;

/**
 * __usePayrollCompanyComponentUrlQuery__
 *
 * To run a query within a React component, call `usePayrollCompanyComponentUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollCompanyComponentUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollCompanyComponentUrlQuery({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *      componentType: // value for 'componentType'
 *   },
 * });
 */
export function usePayrollCompanyComponentUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    PayrollCompanyComponentUrlQuery,
    PayrollCompanyComponentUrlQueryVariables
  > &
    (
      | { variables: PayrollCompanyComponentUrlQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PayrollCompanyComponentUrlQuery,
    PayrollCompanyComponentUrlQueryVariables
  >(PayrollCompanyComponentUrlDocument, options);
}
export function usePayrollCompanyComponentUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PayrollCompanyComponentUrlQuery,
    PayrollCompanyComponentUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PayrollCompanyComponentUrlQuery,
    PayrollCompanyComponentUrlQueryVariables
  >(PayrollCompanyComponentUrlDocument, options);
}
export function usePayrollCompanyComponentUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PayrollCompanyComponentUrlQuery,
        PayrollCompanyComponentUrlQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PayrollCompanyComponentUrlQuery,
    PayrollCompanyComponentUrlQueryVariables
  >(PayrollCompanyComponentUrlDocument, options);
}
export type PayrollCompanyComponentUrlQueryHookResult = ReturnType<
  typeof usePayrollCompanyComponentUrlQuery
>;
export type PayrollCompanyComponentUrlLazyQueryHookResult = ReturnType<
  typeof usePayrollCompanyComponentUrlLazyQuery
>;
export type PayrollCompanyComponentUrlSuspenseQueryHookResult = ReturnType<
  typeof usePayrollCompanyComponentUrlSuspenseQuery
>;
export type PayrollCompanyComponentUrlQueryResult = Apollo.QueryResult<
  PayrollCompanyComponentUrlQuery,
  PayrollCompanyComponentUrlQueryVariables
>;
export const PayrollOnboardDocument = gql`
  query PayrollOnboard($medspaId: String!, $userMedspaId: bigint!) {
    payroll {
      company(medspaId: $medspaId) {
        workerCount
        bankAccountStatus
        latestFeinVerificationStatus
        isBusinessDetailsCompleted
        isPayHistoryCompleted
        isFirstPayroll
        filingAuthorizationBlockingCount
        filingAuthorizationNeedsAttentionCount
        teamSetupEmployeesBlockingCount
        teamSetupContractorsBlockingCount
        teamSetupEmployeesNeedsAttentionCount
        teamSetupContractorsNeedsAttentionCount
        teamSetupCurrentUser
        companyDefinedEmployeeSetupBlockingCount
        companyDefinedEmployeeSetupNeedsAttentionCount
        companyDefinedEmployeeSetupCurrentUser
        taxSetupBlockingCount
        taxSetupNeedsAttentionCount
        taxSetupJurisdictionsMissingTaxId
        businessType
        industryType
        legalName
        phone
        email
        address
        implementationStatus
        isReadyForImplementation
        onboardStatus
        isRegistered
        isInNonMsoState
        documentRequests {
          id
          title
          status
          errors
        }
        fundingFailures {
          id
          title
          status
          errors
        }
      }
    }
    userMedspaByPk(id: $userMedspaId) {
      user {
        fullName
      }
      payrollSignatory {
        title
      }
    }
  }
`;

/**
 * __usePayrollOnboardQuery__
 *
 * To run a query within a React component, call `usePayrollOnboardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollOnboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollOnboardQuery({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *      userMedspaId: // value for 'userMedspaId'
 *   },
 * });
 */
export function usePayrollOnboardQuery(
  baseOptions: Apollo.QueryHookOptions<
    PayrollOnboardQuery,
    PayrollOnboardQueryVariables
  > &
    (
      | { variables: PayrollOnboardQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PayrollOnboardQuery, PayrollOnboardQueryVariables>(
    PayrollOnboardDocument,
    options
  );
}
export function usePayrollOnboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PayrollOnboardQuery,
    PayrollOnboardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PayrollOnboardQuery, PayrollOnboardQueryVariables>(
    PayrollOnboardDocument,
    options
  );
}
export function usePayrollOnboardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PayrollOnboardQuery,
        PayrollOnboardQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PayrollOnboardQuery,
    PayrollOnboardQueryVariables
  >(PayrollOnboardDocument, options);
}
export type PayrollOnboardQueryHookResult = ReturnType<
  typeof usePayrollOnboardQuery
>;
export type PayrollOnboardLazyQueryHookResult = ReturnType<
  typeof usePayrollOnboardLazyQuery
>;
export type PayrollOnboardSuspenseQueryHookResult = ReturnType<
  typeof usePayrollOnboardSuspenseQuery
>;
export type PayrollOnboardQueryResult = Apollo.QueryResult<
  PayrollOnboardQuery,
  PayrollOnboardQueryVariables
>;
export const PayrollPayScheduleDocument = gql`
  query PayrollPaySchedule($medspaId: String!) {
    payroll {
      company(medspaId: $medspaId) {
        paySchedule {
          id
          payFrequency
          nextPayoutDate
        }
      }
    }
  }
`;

/**
 * __usePayrollPayScheduleQuery__
 *
 * To run a query within a React component, call `usePayrollPayScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollPayScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollPayScheduleQuery({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function usePayrollPayScheduleQuery(
  baseOptions: Apollo.QueryHookOptions<
    PayrollPayScheduleQuery,
    PayrollPayScheduleQueryVariables
  > &
    (
      | { variables: PayrollPayScheduleQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PayrollPayScheduleQuery,
    PayrollPayScheduleQueryVariables
  >(PayrollPayScheduleDocument, options);
}
export function usePayrollPayScheduleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PayrollPayScheduleQuery,
    PayrollPayScheduleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PayrollPayScheduleQuery,
    PayrollPayScheduleQueryVariables
  >(PayrollPayScheduleDocument, options);
}
export function usePayrollPayScheduleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PayrollPayScheduleQuery,
        PayrollPayScheduleQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PayrollPayScheduleQuery,
    PayrollPayScheduleQueryVariables
  >(PayrollPayScheduleDocument, options);
}
export type PayrollPayScheduleQueryHookResult = ReturnType<
  typeof usePayrollPayScheduleQuery
>;
export type PayrollPayScheduleLazyQueryHookResult = ReturnType<
  typeof usePayrollPayScheduleLazyQuery
>;
export type PayrollPayScheduleSuspenseQueryHookResult = ReturnType<
  typeof usePayrollPayScheduleSuspenseQuery
>;
export type PayrollPayScheduleQueryResult = Apollo.QueryResult<
  PayrollPayScheduleQuery,
  PayrollPayScheduleQueryVariables
>;
export const PayrollViewInfoDocument = gql`
  query PayrollViewInfo(
    $medspaId: String!
    $skipFundingFailures: Boolean = true
  ) {
    payroll {
      isCurrentUserRegisteredEmployee(medspaId: $medspaId)
      isCurrentUserRegisteredContractor(medspaId: $medspaId)
      isCurrentUserOnboarded(medspaId: $medspaId)
      company(medspaId: $medspaId) @skip(if: $skipFundingFailures) {
        fundingFailures {
          id
          title
          status
          errors
        }
      }
    }
  }
`;

/**
 * __usePayrollViewInfoQuery__
 *
 * To run a query within a React component, call `usePayrollViewInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollViewInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollViewInfoQuery({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *      skipFundingFailures: // value for 'skipFundingFailures'
 *   },
 * });
 */
export function usePayrollViewInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    PayrollViewInfoQuery,
    PayrollViewInfoQueryVariables
  > &
    (
      | { variables: PayrollViewInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PayrollViewInfoQuery, PayrollViewInfoQueryVariables>(
    PayrollViewInfoDocument,
    options
  );
}
export function usePayrollViewInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PayrollViewInfoQuery,
    PayrollViewInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PayrollViewInfoQuery,
    PayrollViewInfoQueryVariables
  >(PayrollViewInfoDocument, options);
}
export function usePayrollViewInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PayrollViewInfoQuery,
        PayrollViewInfoQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PayrollViewInfoQuery,
    PayrollViewInfoQueryVariables
  >(PayrollViewInfoDocument, options);
}
export type PayrollViewInfoQueryHookResult = ReturnType<
  typeof usePayrollViewInfoQuery
>;
export type PayrollViewInfoLazyQueryHookResult = ReturnType<
  typeof usePayrollViewInfoLazyQuery
>;
export type PayrollViewInfoSuspenseQueryHookResult = ReturnType<
  typeof usePayrollViewInfoSuspenseQuery
>;
export type PayrollViewInfoQueryResult = Apollo.QueryResult<
  PayrollViewInfoQuery,
  PayrollViewInfoQueryVariables
>;
export const RunPayrollReadyDocument = gql`
  query RunPayrollReady($medspaId: String!) {
    payroll {
      company(medspaId: $medspaId) {
        runPayrollReady
        onboardStatus
        implementationStatus
      }
    }
  }
`;

/**
 * __useRunPayrollReadyQuery__
 *
 * To run a query within a React component, call `useRunPayrollReadyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunPayrollReadyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunPayrollReadyQuery({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useRunPayrollReadyQuery(
  baseOptions: Apollo.QueryHookOptions<
    RunPayrollReadyQuery,
    RunPayrollReadyQueryVariables
  > &
    (
      | { variables: RunPayrollReadyQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RunPayrollReadyQuery, RunPayrollReadyQueryVariables>(
    RunPayrollReadyDocument,
    options
  );
}
export function useRunPayrollReadyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RunPayrollReadyQuery,
    RunPayrollReadyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RunPayrollReadyQuery,
    RunPayrollReadyQueryVariables
  >(RunPayrollReadyDocument, options);
}
export function useRunPayrollReadySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RunPayrollReadyQuery,
        RunPayrollReadyQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RunPayrollReadyQuery,
    RunPayrollReadyQueryVariables
  >(RunPayrollReadyDocument, options);
}
export type RunPayrollReadyQueryHookResult = ReturnType<
  typeof useRunPayrollReadyQuery
>;
export type RunPayrollReadyLazyQueryHookResult = ReturnType<
  typeof useRunPayrollReadyLazyQuery
>;
export type RunPayrollReadySuspenseQueryHookResult = ReturnType<
  typeof useRunPayrollReadySuspenseQuery
>;
export type RunPayrollReadyQueryResult = Apollo.QueryResult<
  RunPayrollReadyQuery,
  RunPayrollReadyQueryVariables
>;
export const PayrollPreliminaryInfoDocument = gql`
  query PayrollPreliminaryInfo($medspaId: String!) {
    payroll {
      isCurrentUserRegisteredInCheck(medspaId: $medspaId)
      isCompanyRegisteredInCheck(medspaId: $medspaId)
    }
  }
`;

/**
 * __usePayrollPreliminaryInfoQuery__
 *
 * To run a query within a React component, call `usePayrollPreliminaryInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollPreliminaryInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollPreliminaryInfoQuery({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function usePayrollPreliminaryInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    PayrollPreliminaryInfoQuery,
    PayrollPreliminaryInfoQueryVariables
  > &
    (
      | { variables: PayrollPreliminaryInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PayrollPreliminaryInfoQuery,
    PayrollPreliminaryInfoQueryVariables
  >(PayrollPreliminaryInfoDocument, options);
}
export function usePayrollPreliminaryInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PayrollPreliminaryInfoQuery,
    PayrollPreliminaryInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PayrollPreliminaryInfoQuery,
    PayrollPreliminaryInfoQueryVariables
  >(PayrollPreliminaryInfoDocument, options);
}
export function usePayrollPreliminaryInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PayrollPreliminaryInfoQuery,
        PayrollPreliminaryInfoQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PayrollPreliminaryInfoQuery,
    PayrollPreliminaryInfoQueryVariables
  >(PayrollPreliminaryInfoDocument, options);
}
export type PayrollPreliminaryInfoQueryHookResult = ReturnType<
  typeof usePayrollPreliminaryInfoQuery
>;
export type PayrollPreliminaryInfoLazyQueryHookResult = ReturnType<
  typeof usePayrollPreliminaryInfoLazyQuery
>;
export type PayrollPreliminaryInfoSuspenseQueryHookResult = ReturnType<
  typeof usePayrollPreliminaryInfoSuspenseQuery
>;
export type PayrollPreliminaryInfoQueryResult = Apollo.QueryResult<
  PayrollPreliminaryInfoQuery,
  PayrollPreliminaryInfoQueryVariables
>;
export const WorkerOnboardUrlDocument = gql`
  query WorkerOnboardUrl($userMedspaId: ID!) {
    payroll {
      employeeOrContractorOnboardingUrl(userMedspaId: $userMedspaId)
    }
  }
`;

/**
 * __useWorkerOnboardUrlQuery__
 *
 * To run a query within a React component, call `useWorkerOnboardUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkerOnboardUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkerOnboardUrlQuery({
 *   variables: {
 *      userMedspaId: // value for 'userMedspaId'
 *   },
 * });
 */
export function useWorkerOnboardUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkerOnboardUrlQuery,
    WorkerOnboardUrlQueryVariables
  > &
    (
      | { variables: WorkerOnboardUrlQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkerOnboardUrlQuery, WorkerOnboardUrlQueryVariables>(
    WorkerOnboardUrlDocument,
    options
  );
}
export function useWorkerOnboardUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkerOnboardUrlQuery,
    WorkerOnboardUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkerOnboardUrlQuery,
    WorkerOnboardUrlQueryVariables
  >(WorkerOnboardUrlDocument, options);
}
export function useWorkerOnboardUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkerOnboardUrlQuery,
        WorkerOnboardUrlQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkerOnboardUrlQuery,
    WorkerOnboardUrlQueryVariables
  >(WorkerOnboardUrlDocument, options);
}
export type WorkerOnboardUrlQueryHookResult = ReturnType<
  typeof useWorkerOnboardUrlQuery
>;
export type WorkerOnboardUrlLazyQueryHookResult = ReturnType<
  typeof useWorkerOnboardUrlLazyQuery
>;
export type WorkerOnboardUrlSuspenseQueryHookResult = ReturnType<
  typeof useWorkerOnboardUrlSuspenseQuery
>;
export type WorkerOnboardUrlQueryResult = Apollo.QueryResult<
  WorkerOnboardUrlQuery,
  WorkerOnboardUrlQueryVariables
>;
export const PayrollEmployeeDataDocument = gql`
  query PayrollEmployeeData($medspaId: bigint!) {
    medspaByPk(id: $medspaId) {
      id
      payrollCompany {
        isFirstPayroll
      }
    }
    userMedspa(
      where: {
        medspaId: { _eq: $medspaId }
        _or: [
          { payrollEmployee: { checkEmployeeId: { _isNull: false } } }
          { payrollContractor: { checkContractorId: { _isNull: false } } }
        ]
      }
    ) {
      id
      userMedspaRole {
        id
        name
      }
      user {
        id
        firstName
        lastName
        fullName
      }
      payrollContractor {
        id
        startDate
        onboardStatus
        terminationDate
        onboardBlockingTypeSubmitted
        onboardBlockingEinSubmitted
        onboardBlockingAddressSubmitted
        onboardNeedsAttentionSsnSubmitted
        onboardNeedsAttentionSsnValidated
        onboardNeedsAttentionPaymentMethodPreferenceSet
        onboardNeedsAttentionBankAccountExists
        onboardNeedsAttentionBankAccountVerified
      }
      payrollEmployee {
        id
        employmentDate
        onboardStatus
        terminationDate
        onboardBlockingPrimaryWorkplaceSet
        onboardBlockingStartDate
        onboardBlockingDob
        onboardBlockingResidence
        onboardNeedsAttentionSsnSubmitted
        onboardNeedsAttentionSsnValidated
        onboardNeedsAttentionPaymentMethodPreferenceSet
        onboardNeedsAttentionBankAccountExists
        onboardNeedsAttentionBankAccountVerified
        onboardWithholdings {
          id
          name
          status
        }
        onboardCompanyDefinedAttributes {
          id
          name
          status
        }
      }
    }
  }
`;

/**
 * __usePayrollEmployeeDataQuery__
 *
 * To run a query within a React component, call `usePayrollEmployeeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollEmployeeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollEmployeeDataQuery({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function usePayrollEmployeeDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    PayrollEmployeeDataQuery,
    PayrollEmployeeDataQueryVariables
  > &
    (
      | { variables: PayrollEmployeeDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PayrollEmployeeDataQuery,
    PayrollEmployeeDataQueryVariables
  >(PayrollEmployeeDataDocument, options);
}
export function usePayrollEmployeeDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PayrollEmployeeDataQuery,
    PayrollEmployeeDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PayrollEmployeeDataQuery,
    PayrollEmployeeDataQueryVariables
  >(PayrollEmployeeDataDocument, options);
}
export function usePayrollEmployeeDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PayrollEmployeeDataQuery,
        PayrollEmployeeDataQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PayrollEmployeeDataQuery,
    PayrollEmployeeDataQueryVariables
  >(PayrollEmployeeDataDocument, options);
}
export type PayrollEmployeeDataQueryHookResult = ReturnType<
  typeof usePayrollEmployeeDataQuery
>;
export type PayrollEmployeeDataLazyQueryHookResult = ReturnType<
  typeof usePayrollEmployeeDataLazyQuery
>;
export type PayrollEmployeeDataSuspenseQueryHookResult = ReturnType<
  typeof usePayrollEmployeeDataSuspenseQuery
>;
export type PayrollEmployeeDataQueryResult = Apollo.QueryResult<
  PayrollEmployeeDataQuery,
  PayrollEmployeeDataQueryVariables
>;
export const MarkBusinessDetailsCompletedDocument = gql`
  mutation MarkBusinessDetailsCompleted($medspaId: String!) {
    payroll {
      markBusinessDetailsCompleted(medspaId: $medspaId) {
        ok
        message
      }
    }
  }
`;
export type MarkBusinessDetailsCompletedMutationFn = Apollo.MutationFunction<
  MarkBusinessDetailsCompletedMutation,
  MarkBusinessDetailsCompletedMutationVariables
>;

/**
 * __useMarkBusinessDetailsCompletedMutation__
 *
 * To run a mutation, you first call `useMarkBusinessDetailsCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkBusinessDetailsCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markBusinessDetailsCompletedMutation, { data, loading, error }] = useMarkBusinessDetailsCompletedMutation({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useMarkBusinessDetailsCompletedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkBusinessDetailsCompletedMutation,
    MarkBusinessDetailsCompletedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkBusinessDetailsCompletedMutation,
    MarkBusinessDetailsCompletedMutationVariables
  >(MarkBusinessDetailsCompletedDocument, options);
}
export type MarkBusinessDetailsCompletedMutationHookResult = ReturnType<
  typeof useMarkBusinessDetailsCompletedMutation
>;
export type MarkBusinessDetailsCompletedMutationResult =
  Apollo.MutationResult<MarkBusinessDetailsCompletedMutation>;
export type MarkBusinessDetailsCompletedMutationOptions =
  Apollo.BaseMutationOptions<
    MarkBusinessDetailsCompletedMutation,
    MarkBusinessDetailsCompletedMutationVariables
  >;
export const MarkPayHistoryCompletedDocument = gql`
  mutation MarkPayHistoryCompleted($medspaId: String!) {
    payroll {
      markPayHistoryCompleted(medspaId: $medspaId) {
        ok
        message
      }
    }
  }
`;
export type MarkPayHistoryCompletedMutationFn = Apollo.MutationFunction<
  MarkPayHistoryCompletedMutation,
  MarkPayHistoryCompletedMutationVariables
>;

/**
 * __useMarkPayHistoryCompletedMutation__
 *
 * To run a mutation, you first call `useMarkPayHistoryCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPayHistoryCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPayHistoryCompletedMutation, { data, loading, error }] = useMarkPayHistoryCompletedMutation({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useMarkPayHistoryCompletedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkPayHistoryCompletedMutation,
    MarkPayHistoryCompletedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkPayHistoryCompletedMutation,
    MarkPayHistoryCompletedMutationVariables
  >(MarkPayHistoryCompletedDocument, options);
}
export type MarkPayHistoryCompletedMutationHookResult = ReturnType<
  typeof useMarkPayHistoryCompletedMutation
>;
export type MarkPayHistoryCompletedMutationResult =
  Apollo.MutationResult<MarkPayHistoryCompletedMutation>;
export type MarkPayHistoryCompletedMutationOptions = Apollo.BaseMutationOptions<
  MarkPayHistoryCompletedMutation,
  MarkPayHistoryCompletedMutationVariables
>;
export const SendOnboardRemindersToWorkersDocument = gql`
  mutation SendOnboardRemindersToWorkers($medspaId: String!) {
    payroll {
      sendOnboardRemindersToWorkers(medspaId: $medspaId) {
        ok
        message
      }
    }
  }
`;
export type SendOnboardRemindersToWorkersMutationFn = Apollo.MutationFunction<
  SendOnboardRemindersToWorkersMutation,
  SendOnboardRemindersToWorkersMutationVariables
>;

/**
 * __useSendOnboardRemindersToWorkersMutation__
 *
 * To run a mutation, you first call `useSendOnboardRemindersToWorkersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOnboardRemindersToWorkersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOnboardRemindersToWorkersMutation, { data, loading, error }] = useSendOnboardRemindersToWorkersMutation({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useSendOnboardRemindersToWorkersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendOnboardRemindersToWorkersMutation,
    SendOnboardRemindersToWorkersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendOnboardRemindersToWorkersMutation,
    SendOnboardRemindersToWorkersMutationVariables
  >(SendOnboardRemindersToWorkersDocument, options);
}
export type SendOnboardRemindersToWorkersMutationHookResult = ReturnType<
  typeof useSendOnboardRemindersToWorkersMutation
>;
export type SendOnboardRemindersToWorkersMutationResult =
  Apollo.MutationResult<SendOnboardRemindersToWorkersMutation>;
export type SendOnboardRemindersToWorkersMutationOptions =
  Apollo.BaseMutationOptions<
    SendOnboardRemindersToWorkersMutation,
    SendOnboardRemindersToWorkersMutationVariables
  >;
export const StartImplementationDocument = gql`
  mutation StartImplementation($medspaId: String!) {
    payroll {
      startImplementation(medspaId: $medspaId) {
        ok
        message
      }
    }
  }
`;
export type StartImplementationMutationFn = Apollo.MutationFunction<
  StartImplementationMutation,
  StartImplementationMutationVariables
>;

/**
 * __useStartImplementationMutation__
 *
 * To run a mutation, you first call `useStartImplementationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartImplementationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startImplementationMutation, { data, loading, error }] = useStartImplementationMutation({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useStartImplementationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartImplementationMutation,
    StartImplementationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartImplementationMutation,
    StartImplementationMutationVariables
  >(StartImplementationDocument, options);
}
export type StartImplementationMutationHookResult = ReturnType<
  typeof useStartImplementationMutation
>;
export type StartImplementationMutationResult =
  Apollo.MutationResult<StartImplementationMutation>;
export type StartImplementationMutationOptions = Apollo.BaseMutationOptions<
  StartImplementationMutation,
  StartImplementationMutationVariables
>;
export const CreateOrUpdateSignatoryDocument = gql`
  mutation CreateOrUpdateSignatory($medspaId: String!, $title: String!) {
    payroll {
      createOrUpdateSignatory(medspaId: $medspaId, title: $title) {
        ok
        message
      }
    }
  }
`;
export type CreateOrUpdateSignatoryMutationFn = Apollo.MutationFunction<
  CreateOrUpdateSignatoryMutation,
  CreateOrUpdateSignatoryMutationVariables
>;

/**
 * __useCreateOrUpdateSignatoryMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateSignatoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateSignatoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateSignatoryMutation, { data, loading, error }] = useCreateOrUpdateSignatoryMutation({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateOrUpdateSignatoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOrUpdateSignatoryMutation,
    CreateOrUpdateSignatoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateOrUpdateSignatoryMutation,
    CreateOrUpdateSignatoryMutationVariables
  >(CreateOrUpdateSignatoryDocument, options);
}
export type CreateOrUpdateSignatoryMutationHookResult = ReturnType<
  typeof useCreateOrUpdateSignatoryMutation
>;
export type CreateOrUpdateSignatoryMutationResult =
  Apollo.MutationResult<CreateOrUpdateSignatoryMutation>;
export type CreateOrUpdateSignatoryMutationOptions = Apollo.BaseMutationOptions<
  CreateOrUpdateSignatoryMutation,
  CreateOrUpdateSignatoryMutationVariables
>;
